import CarManagmentProvider, {
  useCarManagmentContext
} from 'providers/CarManagmentProvider';
import dayjs /* , { Dayjs }*/ from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
require('dayjs/locale/pt');
dayjs.extend(localeData);
dayjs.extend(LocalizedFormat);
dayjs.extend(weekday);
// import 'flatpickr/dist/themes/material_blue.css'; // or any theme
import BasicGanttChart, {
  Trip
} from 'components/charts/dhtmlx/BasicGanttChart';
import { useCallback, useMemo } from 'react';
import CalendarAddNewEventModal from 'components/modals/CarManagementAddNewTripModal';
import CalendarProvider from 'providers/CalendarProvider';
import { getPlannerPrefetchRange } from 'helpers/utils';

const index = () => {
  return (
    <CalendarProvider loadTripsOnMount={false}>
      <CarManagmentProvider loadTripsOnMount={false}>
        <Calendar />
      </CarManagmentProvider>
    </CalendarProvider>
  );
};

const Calendar = () => {
  const { plannerTrips, fetchTripsForRange, isLoadingTripRange, tripsError } =
    useCarManagmentContext();

  const handlePlannerDateChange = useCallback(
    (date: Date) => {
      void fetchTripsForRange(getPlannerPrefetchRange(date));
    },
    [fetchTripsForRange]
  );

  const formatedTrips = useMemo(() => {
    return (plannerTrips || [])
      .filter(
        trip =>
          trip.status === 'Aprovado' ||
          trip.status === 'Pendente' ||
          trip.status === 'Recusado'
      )
      .map(
        trip =>
          ({
            id: trip.id as number,
            grupo: trip.grupo,
            text: trip.title,
            companiesList: trip.companiesList,
            passenger: trip.passenger || 'Unknown',
            listPassenger: trip.usersList,
            outsideUsers: trip.outsideUsers,
            carPlate: trip.carPlate,
            start_date: new Date(trip.start),
            end_date: new Date(trip.end),
            duration: trip.end
              ? (new Date(trip.end).getTime() -
                  new Date(trip.start).getTime()) /
                (1000 * 60 * 60)
              : 1,
            originalStart: new Date(trip.start),
            originalEnd: new Date(trip.end || trip.start),
            isClipped: trip.takecar === 'Y' || trip.leavecar === 'Y',
            takeCar: trip.takecar,
            leaveCar: trip.leavecar,
            canChangeTime: trip.canChangeTime
          }) as Trip
      );
  }, [plannerTrips]);

  return (
    <div>
      <BasicGanttChart
        trips={formatedTrips}
        rightColumn={'name'}
        initialViewMode={'week'}
        onPlannerDateChange={handlePlannerDateChange}
      />
      {tripsError && !isLoadingTripRange && (
        <div className="alert alert-danger" role="alert">
          {tripsError}
        </div>
      )}
      <CalendarAddNewEventModal />
    </div>
  );
};

export default index;
